const LINK = 'LINK';
const HANDLE = 'HANDLE';
const OPEN_WINDOW = 'OPEN_WINDOW';

export { LINK, HANDLE, OPEN_WINDOW };
